// extracted by mini-css-extract-plugin
export var checkbox = "checkbox-module--checkbox--2GAEK";
export var checkbox_cont = "checkbox-module--checkbox_cont--CKkqv";
export var checkbox_icon = "checkbox-module--checkbox_icon--2yNuV";
export var checkbox_label = "checkbox-module--checkbox_label--2RBL6";
export var checkbox_error = "checkbox-module--checkbox_error--1Hbye";
export var error = "checkbox-module--error--35FH_";